import Flickity from 'flickity';

const initCarousels = (elements) => {
    elements.forEach((element) => {
        let contain = true;
        let dots = false;
        let prevNext = false;
        let watchCss = false;
        let align = 'left';
        let draggable = false;
        let wrap = false;
        let fullScreen = false;
        let setGallerySize = true;
        let autoplay = false;
        let adaptive = false;

        const buttons = element.querySelectorAll('.js-carousel-button');

        if (element.dataset.noContain) {
            contain = false;
        }

        if (element.dataset.draggable) {
            draggable = true;
        }

        if (element.dataset.carouselDots) {
            dots = true;
        }

        if (element.dataset.align) {
            align = element.dataset.align;
        }

        if (element.dataset.carouselNav) {
            prevNext = true;
        }

        if (element.dataset.watchCss) {
            watchCss = true;
        }

        if (element.dataset.wrap) {
            wrap = true;
        }

        if (element.dataset.fullScreen) {
            fullScreen = true;
        }

        if (element.dataset.customSize) {
            setGallerySize = false;
        }

        if (element.dataset.autoplay) {
            autoplay = 6000;
        }

        if (element.dataset.adaptive) {
            adaptive = true;
        }

        const flickityOptions = {
            autoPlay: autoplay,
            cellAlign: align,
            wrapAround: wrap,
            contain,
            prevNextButtons: prevNext,
            arrowShape: 'M46.1563 91.5L56.8325 80.895L33.6725 57.735L95 57.735L95 42.765L33.6725 42.765L56.8325 19.605L46.1563 9L5 50.25L46.1563 91.5Z',
            pageDots: dots,
            draggable,
            setGallerySize,
            watchCSS: watchCss,
            fullscreen: fullScreen,
            adaptiveHeight: adaptive,
            cellSelector: '.js-carousel-cell'
        };

        // Force slide height to match
        if (element.dataset.matchHeight) {
            flickityOptions.on = {};

            flickityOptions.on.ready = () => {
                const slides = element.querySelectorAll('.flickity-cell');

                slides.forEach((slide) => {
                    slide.style.height = '100%';
                });
            };
        }

        const carousel = new Flickity(element, flickityOptions); // eslint-disable-line;

        // Force resize for wrapped ones
        if (element.dataset.wrap || element.dataset.fade) {
            carousel.resize();
        }

        if (buttons && buttons.length > 0) {
            buttons.forEach(button => {
                button.addEventListener('click', () =>{
                    if(button.dataset.control == 'prev') {
                        carousel.previous();
                    } else if(button.dataset.control == 'next') {
                        carousel.next();
                    }
                })
            })
        }

    });
};

export { initCarousels as default };
